import React, { useState } from 'react';
import './EditInwardWeightModal.css';
import { API_BASE_URL } from '../../config';

const EditInwardWeightModal = ({ isOpen, entry, onClose, onSave }) => {
  const [tareWeight, setTareWeight] = useState(entry?.tare_weight || '');
  const [weightSlipNumber, setWeightSlipNumber] = useState(entry?.weight_slip_number || '');
  const [error, setError] = useState('');

  // Always use today's date in IST for outdate
  const getTodayIST = () => {
    const now = new Date();
    const istNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    return istNow.toISOString().slice(0, 10);
  };
  const outdate = getTodayIST();

  if (!isOpen || !entry) return null;

  // Calculate net weight
  const grossWeight = parseFloat(entry.gross_weight || 0);
  const tare = parseFloat(tareWeight || 0);
  const netWeight = (grossWeight || 0) - (tare || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation: tare weight can be zero but not negative
    if (tare < 0) {
      setError('Tare weight cannot be negative.');
      return;
    }
    if (netWeight < 0) {
      setError('Net weight cannot be negative. Please check gross and tare weight.');
      return;
    }
    setError('');
    // Get current IST time for timeout
    const now = new Date();
    const timeOutIST = now.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata'
    });

    const token = localStorage.getItem('token');
    await fetch(`${API_BASE_URL}/api/inward-entries/${entry.id}/weights`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        tare_weight: tareWeight,
        weight_slip_number: weightSlipNumber,
        time_out: timeOutIST,
        net_weight: netWeight,
        outdate // <-- changed from out_date to outdate
      })
    });
    onSave({
      tare_weight: tareWeight,
      weight_slip_number: weightSlipNumber,
      time_out: timeOutIST,
      net_weight: netWeight,
      outdate // <-- changed from out_date to outdate
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal edit-inward-weight-modal">
        <h3>Edit Weights for Serial #{entry.serial_number}</h3>
        <form onSubmit={handleSubmit}>
          {/* Show error if exists */}
          {error && (
            <div className="error-message" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}
          <div className="form-group">
            <label>Gross Weight</label>
            <input type="number" value={grossWeight} disabled />
          </div>
          <div className="form-group">
            <label>Tare Weight</label>
            <input
              type="number"
              step="0.01"
              value={tareWeight}
              onChange={e => setTareWeight(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Net Weight</label>
            <input type="number" value={netWeight} disabled />
          </div>
          <div className="form-group">
            <label>Weight Slip Number</label>
            <input
              type="text"
              value={weightSlipNumber}
              onChange={e => setWeightSlipNumber(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Out Date</label>
            <input
              type="date"
              value={outdate}
              disabled
              readOnly
            />
          </div>
          <div className="modal-buttons">
            <button type="submit" className="submit-button">Save</button>
            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditInwardWeightModal;
